import React from 'react';
import { Box } from '@mui/material';

const LeftStripeCard = ({ stripeColor, stripeWidth = 4, selected, onClick, sx, children }) => (
  <Box
    onClick={onClick}
    sx={[
      {
        cursor: onClick ? 'pointer' : 'default',
        p: 1.5,
        borderRadius: '10px',
        borderTop: '1px solid',
        borderRight: '1px solid',
        borderBottom: '1px solid',
        borderTopColor: selected ? 'primary.main' : 'divider',
        borderRightColor: selected ? 'primary.main' : 'divider',
        borderBottomColor: selected ? 'primary.main' : 'divider',
        borderLeft: `${stripeWidth}px solid`,
        borderLeftColor: stripeColor || 'divider',
        bgcolor: selected ? 'action.selected' : 'background.paper',
        transition: 'background-color 0.15s ease, border-color 0.15s ease',
      },
      onClick ? { '&:hover': { bgcolor: 'action.hover' } } : {},
      ...(Array.isArray(sx) ? sx : [sx || {}]),
    ]}
  >
    {children}
  </Box>
);

export default LeftStripeCard;
